/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Sortby2Inputs */

const id_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan berdasarkan`)
};

const ms_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun mengikut`)
};

const da_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter efter`)
};

const de_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren nach`)
};

const en_us2_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by`)
};

const es_es2_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const es_mx2_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const fil_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ayon sa`)
};

const fr_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier par`)
};

const it_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina per`)
};

const hu_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendezés`)
};

const nl_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteren op`)
};

const no_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter etter`)
};

const pl_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj według`)
};

const pt_br2_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const pt_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const ro_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează după`)
};

const fi_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä`)
};

const sv_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera efter`)
};

const vi_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp theo`)
};

const tr_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sırala`)
};

const cs_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit podle`)
};

const bg_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране по`)
};

const ru_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать по`)
};

const uk_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати за`)
};

const ar_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب حسب`)
};

const hi_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसके अनुसार क्रमबद्ध करें`)
};

const th_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดเรียงตาม`)
};

const ja_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並び替え`)
};

const zh_cn2_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const zh_hant1_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const ko_offerdetail_achievements_sortby2 = /** @type {(inputs: Offerdetail_Achievements_Sortby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬 기준`)
};

/**
* | output |
* | --- |
* | "Sort by" |
*
* @param {Offerdetail_Achievements_Sortby2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_sortby2 = /** @type {((inputs?: Offerdetail_Achievements_Sortby2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Sortby2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_sortby2(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_sortby2(inputs)
	if (locale === "da") return da_offerdetail_achievements_sortby2(inputs)
	if (locale === "de") return de_offerdetail_achievements_sortby2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_sortby2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_sortby2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_sortby2(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_sortby2(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_sortby2(inputs)
	if (locale === "it") return it_offerdetail_achievements_sortby2(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_sortby2(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_sortby2(inputs)
	if (locale === "no") return no_offerdetail_achievements_sortby2(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_sortby2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_sortby2(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_sortby2(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_sortby2(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_sortby2(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_sortby2(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_sortby2(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_sortby2(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_sortby2(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_sortby2(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_sortby2(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_sortby2(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_sortby2(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_sortby2(inputs)
	if (locale === "th") return th_offerdetail_achievements_sortby2(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_sortby2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_sortby2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_sortby2(inputs)
	return ko_offerdetail_achievements_sortby2(inputs)
});
export { offerdetail_achievements_sortby2 as "offerDetail.achievements.sortBy" }